import React, { useState } from 'react';
import {
  Button,
} from '@material-ui/core';

import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { validateSelfEnrolledPatient } from '../../../services/customer.service';

const CancelSelfEnrolledPatient = ({ data }) => {
    const { patient_id, program_id } = data;

  const [state, setState] = useState({
    openConfirmation: false,
    openValidateConfirmation: true,
    modalTitle: 'Patient Self Enrollment',
    errorMessage: null,
    successMessage: 'Patient Registration has been cancelled',
    isLoading: false,
    latestMessage: '',
    messageLogId: null,
    submitButtonEnabled: false,
  });

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openConfirmation: false,
      openValidateConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onValidate = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const { message } = await validateSelfEnrolledPatient({
        customer_id: patient_id,
        program_id,
        action: 'cancel',
      });
      
      setState(prev => ({
        ...prev,
        openValidateConfirmation: false,
        successMessage: message
      }));
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false, openValidateConfirmation: false, openConfirmation: true }));
    }
  };

  const {
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    openValidateConfirmation
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {
        openValidateConfirmation && 
        <Button
          onClick={onValidate}
          variant="contained"
          color="primary"
          disabled={false}
        >
          Cancel
        </Button>
      }
    </>
  );

  return (
    <>
      <Dialog
        key="cancel-self-enrolled-patient"
        open={openValidateConfirmation}
        title={modalTitle}
        content = {`Are you sure to cancel the patient registration?`}
        children={formButtons}
        onSubmit={onValidate}
        onClose={handleClose}
      />
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title= 'Patient Self Enrollment'
        content={errorMessage || successMessage}
        children={formButtons}
        onClose={handleClose}
      />
      <Button variant="contained" color="primary" onClick={() => {
         setState(prev => ({
          ...prev,
          openValidateConfirmation: true,
        }));
      }} style={{ marginRight: 8 }}>
        Cancel
      </Button>
    </>
  );
};

export default CancelSelfEnrolledPatient;